import React from 'react'
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
// import './DevicesMenu.css'

const DevicesMenu = (props) => {
  return (
    <UncontrolledDropdown nav inNavbar>
      <DropdownToggle nav caret className="glyphicons glyphicons-hdd">
        <p className="nav-link-p">{props.label}</p>
      </DropdownToggle>
      <DropdownMenu className="submenu">
        <DropdownItem>
          <a href="/ui/#!/devices" className="glyphicons glyphicons-hdd">
            Overview
          </a>
        </DropdownItem>
        <DropdownItem>
          <a
            href="/ui/#!/devices/versions"
            className="glyphicons glyphicons-info-sign"
          >
            Component Versions
          </a>
        </DropdownItem>
        <DropdownItem>
          <a
            href="/ui/#!/devices/downloadFiles/create/"
            className="glyphicons glyphicons-inbox-out"
          >
            Send to Device
          </a>
        </DropdownItem>
        <DropdownItem>
          <a
            href="/ui/#!/devices/downloadFiles"
            className="glyphicons glyphicons-calendar"
          >
            Update History
          </a>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}
export default DevicesMenu
